var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03548 14.5L6.60828 14.117L7.18995 11.9439C6.31927 11.6226 5.51007 11.1545 4.79749 10.5597L3.20621 12.1524L2.16038 11.1061L3.7524 9.51421C2.85371 8.43747 2.24988 7.14573 2 5.76545L3.45455 5.5C4.01552 8.60697 6.73245 10.9642 10 10.9642C13.2668 10.9642 15.9845 8.60697 16.5455 5.5L18 5.76471C17.7505 7.14518 17.1469 8.43718 16.2483 9.51421L17.8396 11.1061L16.7938 12.1524L15.2025 10.5597C14.4899 11.1545 13.6807 11.6226 12.8101 11.9439L13.3917 14.1177L11.9645 14.5L11.3821 12.3262C10.4674 12.483 9.53263 12.483 8.61789 12.3262L8.03548 14.5Z",
    fill: "#13161F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/Hide.921f7cef43a826c3e51a1eba711e0f42.svg";
export { ForwardRef as ReactComponent };